import type { SlotMachineConfig, SlotSymbolDef } from '../../widgets/slot/types';

/** Default 7-symbol roster used by the slot demo. Weighted so common fruit
 * symbols (cherry/lemon/orange) land far more often than the high-payout
 * symbols (gem/seven). */
export const DEFAULT_SLOT_SYMBOLS: readonly SlotSymbolDef[] = [
  { id: 'cherry', glyph: '🍒', tint: 0xff3b6b, weight: 5 },
  { id: 'lemon', glyph: '🍋', tint: 0xffd23b, weight: 5 },
  { id: 'orange', glyph: '🍊', tint: 0xff8a3d, weight: 4 },
  { id: 'bell', glyph: '🔔', tint: 0xffcc4d, weight: 3 },
  { id: 'star', glyph: '⭐', tint: 0xfff59d, weight: 2 },
  { id: 'seven', glyph: '7️⃣', tint: 0xff5252, weight: 1 },
  { id: 'gem', glyph: '💎', tint: 0x42e2f5, weight: 1 },
];

/** Default 5×3 slot machine configuration — the MMS layout. Symbol size
 * tuned to fit a 5-reel grid on phone widths (5 × 72 + 4 × 8 spacing +
 * 32 frame padding ≈ 424px). Smaller phones still need a scale-to-fit
 * step in the host scene's layout; the {@link SlotMachineConfig} itself
 * stays at native size.
 *
 * <p>Spin timings tuned for "satisfying but quick" — long enough for
 * the left-to-right reveal to feel deliberate, short enough that the
 * player can spin again without waiting. */
export const DEFAULT_SLOT_CONFIG: SlotMachineConfig = {
  reelCount: 5,
  visibleRows: 3,
  symbolSize: 72,
  symbols: DEFAULT_SLOT_SYMBOLS,
  spin: {
    staggerMs: 220,
    stopDurationMs: 600,
    scrollSpeed: 1800,
    minSpinMs: 600,
  },
};

/** The "wild" symbol id in the default symbol roster — the star. */
export const DEFAULT_SLOT_WILD_SYMBOL_ID = 'star';
